import { Field as BaseField } from "@base-ui/react/field";
import { Switch as BaseSwitch } from "@base-ui/react/switch";
import clsx from "clsx";
import type { ReactNode } from "react";
import styles from "./Switch.module.css";

export interface SwitchProps {
  label: ReactNode;
  description?: ReactNode;
  checked?: boolean;
  defaultChecked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  /** Shows the switch as busy (the change is being saved). */
  pending?: boolean;
  name?: string;
  className?: string;
}

/** An on/off setting that applies immediately (Base UI Switch). Use Checkbox inside forms with a Save button. */
export function Switch({
  label,
  description,
  checked,
  defaultChecked,
  onCheckedChange,
  disabled,
  pending,
  name,
  className,
}: SwitchProps) {
  return (
    <BaseField.Root name={name} disabled={disabled} className={clsx(styles.field, className)}>
      <BaseField.Label className={styles.label}>
        <span className={styles.text}>{label}</span>
        <BaseSwitch.Root
          className={styles.track}
          checked={checked}
          defaultChecked={defaultChecked}
          onCheckedChange={onCheckedChange ? (next) => onCheckedChange(next) : undefined}
          aria-busy={pending || undefined}
        >
          <BaseSwitch.Thumb className={styles.thumb} />
        </BaseSwitch.Root>
      </BaseField.Label>
      {description ? <BaseField.Description className={styles.description}>{description}</BaseField.Description> : null}
    </BaseField.Root>
  );
}
